module.exports = __webpack_public_path__ + "img/tappy-big-blue-bold.a5581503.svg";